/* eslint-disable */

import React, { useState } from "react";
import styled from "styled-components";
import GlobalStyles from "../Styles/Index";
import LocationForm from "./LocationForm";
import ShipmentForm from "./ShipmentForm";

import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";
import { Colors } from "../../assets/Res/Colors";
import { PrimaryButton } from "../Button/Index";
import axios from "axios";
import { formatDate } from "../../utils";

const URL = process.env.URL = 'https://usm-logistics-server.onrender.com/api/v1'

const Wrapper = styled.div`
  width: 80%;
  margin: 5vh 10% 5vh 10%;
`;

const QuoteWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  //   margin: 5vh 10% 5vh 10%;

  @media (max-width: 1400px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin: 0px;

  }
`;

const HeadText = styled.div`
  font-family: Helvetica;
  font-size: 1.7rem;
  text-align: left;
  width: 100%;
  padding: 15px 0px 5px 0px;

  @media (max-width: 1400px) {
    width: 100%;
    font-size: 1.5rem;
  }
`;

const NormalText = styled.div`
  font-family: Helvetica;
  font-size: 1rem;
  text-align: ${(props) => (props.align ? props.align : "left")};
  opacity: 0.5;
  padding: 5px 0px 5px 0px;
  width: ${(props) => (props.width ? props.width : "")};

  @media (max-width: 1400px){
    font-size: 0.8rem;
    width: ${(props) => props.smallWidth ? props.smallWidth : ""}
  }
`;

const Quote = ({ payload, handleChange }) => {

  const [loading, setLoading] = useState(Boolean);
  const [quote, setQuote] = useState({});

  const getQuote = async () => {
    try {
      setLoading(true)
      let resp = await axios.post(`${URL}/quote/get/quick-quote`, payload);
      if (resp) {
        console.log(resp.data.data);
        setQuote(resp.data.data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  return (
    <>
      <Wrapper>
        <HeadText>Check Quote</HeadText>
        <NormalText>
          Get a quick quote for your package, international or local shipment,
          small package or full container
        </NormalText>
        <QuoteWrapper>
          <QuoteDetails handleChange={handleChange}
            payload={payload}
            getQuote={getQuote} />
          <QuoteResult loading={loading}
            quote={quote} />
        </QuoteWrapper>
      </Wrapper>
    </>
  );
};

const QuoteDetails = ({ handleChange, payload, getQuote }) => {
  return (
    <>
      <LocationWrapper style={{ ...GlobalStyles.HorizontalFlex }}>
        <HeadText>Location Details</HeadText>
        <LocationForm
          handleChange={handleChange}
        />

        <HeadText>Shipment Details</HeadText>
        <ShipmentForm handleChange={handleChange}
          payload={payload}
          getQuote={getQuote} />
      </LocationWrapper>
    </>
  );
};

const LocationWrapper = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  @media (max-width: 1400px){
    width: 100%;

  }
`;

const QuoteResult = ({ loading, quote }) => {
  return (
    <>
      <LocationWrapper style={{ ...GlobalStyles.HorizontalFlex }}>
        <HeadText>Quote Result</HeadText>
        {loading ? <Stack spacing={1} width={"100%"} height={'70vh'} marginTop={'5vh'}>
          <Skeleton variant="rectangular" width="100%" height={150} />
          <Skeleton variant="rounded" width="80%" height={50} />
          <Skeleton variant="rounded" width="60%" height={30} />
        </Stack> : <QuoteResultWrapper>
          {quote?.totalCost ? <QuoteCard quote={quote} /> :
            <>
              <BoldText>Oops!, nothing to show here</BoldText>
              <NormalText width={"65%"} align={"center"} smallWidth={'90%'}>
                Please fill the necessary information provided in the location and
                shipment sectionto display your quote here
              </NormalText>
            </>}
        </QuoteResultWrapper>}
      </LocationWrapper>
    </>
  );
};

const BoldText = styled.div`
  font-family: Helvetica;
  font-size: 2rem;
  font-weight: bolder;
  width: 60%;
  text-align: center;
`;

const QuoteResultWrapper = styled.div`
  width: 100%;
  min-height: 70vh;
  height: fit-content;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background-color: #d9d9d933;
`;


const QuoteCard = ({ quote }) => {
  return (
    <>
      <QuoteCardWrapper style={{ ...GlobalStyles.HorizontalFlex, flexDirection: "row", alignItems: "flex-end" }}>
        <FlexWrap>
          <Banner>Details and addsOn</Banner>
          <NormalText>Estimated Quote</NormalText>
          <HeadText>{formatDate(quote?.createdAt)}</HeadText>
          <NormalText>Bookings end by 23, august from 4pm for a pickup the same day</NormalText>
        </FlexWrap>
        <FlexWrap width={'30%'}>
          <HeadText>${quote?.totalCost}</HeadText>
          <PrimaryButton width={'60%'} text={'Book Now'} padding={'5px'} color={'#FFFFFF99'} />
        </FlexWrap>
      </QuoteCardWrapper>
    </>
  )
}

const QuoteCardWrapper = styled.div`
width: 80%;
background-color: ${Colors.YELLOW};
border-radius: 10px;
padding: 20px;
font-family: Helvetica;

@media (max-width: 900px){
  flex-direction: column !important;
}
`;
const FlexWrap = styled.div`
height: auto;
width: ${(props) => props.width ? props.width : "50%"};
font-family: Helvetica;

@media (max-width: 900px){
  width: 100%;
}
`;

const Banner = styled.div`
text-align: center;
border-radius: 20px;
background-color: #FFFFFF99;
padding: 10px;
width: fit-content;
margin: 2vh 0px 2vh 0px;

@media (max-width: 900px){

}
`


export default Quote;
